import React from 'react'
import styled from '@emotion/styled'
import { FormControl, MenuItem, Select } from '@material-ui/core'
import { TagDropdown } from '../TagDropdown'

const StyledSelect = styled(Select)`
  width: 235px;
  padding: 0px;
  div {
    padding: 8px;
  }
`

const Label = styled.div`
  margin-bottom: 10px;
`

const StyledFormControl = styled(FormControl)`
  margin-bottom: 10px;
`

const shiftTypes = [
  { id: 1, label: 'Assign Only', value: true },
  { id: 2, label: 'Eligible staff can pickup', value: false },
]

export const Options = ({
  handler,
  shift,
  shiftIndex,
  departments,
  staffDepartments,
  hasStaff,
  isFacility,
  showTagManagement,
}) => {
  const { shiftType, department, tags } = shift
  const updateShiftType = ({ target }) => handler({ ...shift, ...{ shiftType: target.value } }, shiftIndex)
  const updateDepartment = ({ target }) => handler({ ...shift, ...{ department: target.value } }, shiftIndex)
  const updateTags = (value) => handler({ ...shift, ...{ tags: value } }, shiftIndex)
  const listDepartments = hasStaff ? staffDepartments : departments
  return (
    <div>
      {shift.type !== 'agency' && !hasStaff && (
        <>
          <Label>Shift Type</Label>
          <StyledFormControl variant="outlined">
            <StyledSelect onChange={updateShiftType} value={shiftType}>
              {shiftTypes.map((type) => (
                <MenuItem key={type.id} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </StyledSelect>
          </StyledFormControl>
        </>
      )}
      {shift.type === 'inHouse' && showTagManagement && (
        <>
          <Label>Add tags (optional)</Label>
          <TagDropdown tags={tags || []} setTags={updateTags} type="position" />
        </>
      )}
      {isFacility && (
        <>
          <Label>Department</Label>
          <StyledFormControl variant="outlined">
            <StyledSelect value={department} displayEmpty onChange={updateDepartment}>
              <MenuItem value={null} disabled>
                Select department
              </MenuItem>
              {listDepartments.map((dpm) => (
                <MenuItem key={dpm.id} value={dpm.id}>
                  {dpm.name}
                </MenuItem>
              ))}
            </StyledSelect>
          </StyledFormControl>
        </>
      )}
    </div>
  )
}
